<template>
  <BaseModal :value="true" id="sms-order-modal" @input="close">
    <h1 class="font-bold w-full text-center">Send order to customer by SMS</h1>
    <form @submit.prevent="sendOrder" class="flex flex-col my-10">
      <label for="phone">Phone number</label>
      <input
        id="phone"
        type="text"
        class="regular clear bordered"
        v-model="phone"
        @keyup="cleanPhone()"
        required
      />
      <label for="message" class="mt-4">Message for your customer</label>
      <textarea
        id="message"
        class="regular clear bordered h-32"
        v-model="message"
        placeholder="Add extra info for your customer"
      >
      </textarea>
      <div
        class="rounded-md overflow-hidden w-full text-red-700 bg-red-200 p-4 mb-4 my-4"
        v-if="alert"
      >
        {{ alert }}
      </div>
      <button
        type="submit"
        class="btn-success-button w-48 mt-6 mx-auto text-center"
      >
        <template v-if="!loading">
          Send order
        </template>
        <BaseMiniSpinner v-else class="mx-auto" />
      </button>
    </form>
  </BaseModal>
</template>
<script>
import { sendOrderSMS } from "@/api/store/OrdersService.js";
export default {
  name: "SMSOrderModal",
  props: {
    orderNumber: {
      type: String,
      required: true
    },
    customerPhone: {
      type: String,
      required: false,
      default: ""
    }
  },
  data() {
    return {
      phone: "+1",
      loading: false,
      message: "",
      alert: ""
    };
  },
  mounted() {
    this.phone = this.customerPhone.replace(/[^0-9+]/g, "");
  },
  methods: {
    validatePhone(phone) {
      const regex = /^\+(?:[0-9] ?){6,14}[0-9]$/;

      return regex.test(phone);
    },
    cleanPhone() {
      this.phone = this.phone.replace(/[^0-9+]/g, "");
    },
    sendOrder() {
      this.alert = "";
      if (!this.validatePhone(this.phone)) {
        this.alert =
          "The phone should include the country code (+1) and 10 digits (regular numbers)";
        return;
      }
      this.loading = true;
      sendOrderSMS(this.orderNumber, this.phone, this.message)
        .then(() => {
          this.$toast.open({
            message: `Order sent by SMS`,
            type: "success",
            position: "top-right"
          });
          this.$emit("close");
        })
        .catch(() => {
          this.$toast.open({
            message: `Error sending SMS`,
            type: "error",
            position: "top-right"
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    close(val) {
      if (!val) {
        this.$emit("close");
      }
    }
  }
};
</script>
<style>
#sms-order-modal .modal-content {
  width: 400px;
  min-height: 500px;
  height: auto;
}
#sms-order-modal.modal {
  padding-top: 180px;
}

/* Movil: sin los 180px (el #id le ganaba a la regla de BaseModal que los
   quita) y a pantalla completa: 400px no cabian y el teclado tapaba el input */
@media (max-width: 767px) {
  #sms-order-modal.modal {
    padding: 0;
  }

  #sms-order-modal .modal-content {
    width: 100%;
    height: 100%;
    min-height: 0;
    max-height: none;
    padding: 12px 12px calc(12px + env(safe-area-inset-bottom));
    border-radius: 0;
    overflow-y: auto;
  }

  #sms-order-modal .modal-content > .close {
    top: 4px;
    right: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    padding: 0;
    font-size: 32px;
    color: #374151;
  }

  #sms-order-modal input,
  #sms-order-modal textarea {
    font-size: 16px;
  }
}
</style>
